export default "__VITE_ASSET__6a8f9fe7__"